import { combineReducers } from "redux";
import { authentication } from "./authentication.reducer";
import { registration } from "./registration.reducer";
import { parametersWidgets, snackbar, appLogo, userProfile } from "./app.reducer";
import { labels } from "../reducers/labels.reducer";
import { path, location, submit } from "./path.reducer";
import { accountId, browserDetect } from "./app.reducer";
import {loginLodingState} from "../components/e_home-page/model/reducer"
import {
  searchSubmitReducer,
  faqReducer,
  linksReducer,
} from "../components/home-page/content-section/model/content-reducer";
import {heroContentReducer} from "../components/home-page/hero-section/model/hero-reducer"
import {announcementReducer} from "../components/home-page/announcement-banner/model/announcement-reducer"
import {balanceDetails} from "../components/quickPay-new/quick-pay-account-balance/model/quick-pay-reducer"
import { updateSelectedAnnouncementVal } from "../components/home-page/announcement-banner/model/announcement-reducer";
const rootReducer = combineReducers({
  authentication,
  snackbar,
  registration,
  parametersWidgets,
  labels,
  path,
  location,
  accountId,
  submit,
  searchResults: searchSubmitReducer,
  faqs: faqReducer,
  links: linksReducer,
  appLogo,
  userProfile,
  announcementReducer,
  balanceDetails,
  updateSelectedAnnouncementVal,
  browserDetect,
  loginLodingState
  //content:heroContentReducer
});

export default rootReducer;
